import React from "react";
import { Link } from "react-router-dom";
import f1 from "../assets/a1.webp";

export default function BlogDetail() {
  return (
    <section className="max-w-[89%] mx-auto px-6 py-16">
      {/* Cover Image */}
      <div className="relative rounded-2xl overflow-hidden shadow-xl">
        <img
          src={f1}
          alt="Blog Cover"
          className="w-full h-96 object-cover transition-transform duration-500 hover:scale-105"
        />
        <div className="absolute bottom-4 left-4 bg-black/60 text-white px-3 py-1 rounded-md text-sm">
          Aug 16, 2025 • 2 min read
        </div>
      </div>

      {/* Title */}
      <h1 className="text-4xl md:text-5xl font-extrabold mt-10 text-gray-900 leading-tight">
        Our First Office
      </h1>

      {/* Meta Info */}
      <p className="text-gray-500 mt-2 text-sm">By Ecrop Editorial Team</p>

      {/* Content */}
      <div className="mt-10 space-y-8 text-gray-700 text-base md:text-lg leading-relaxed">
        <p className="first-letter:text-4xl first-letter:font-bold first-letter:text-green-600">
          This is a simple blog detail page. Here you can write the full content
          of your blog with paragraphs, headings, and images. Since this page is
          static, you can later replace it with dynamic data coming from Firebase.
        </p>

        {/* Highlighted Quote */}
        <blockquote className="border-l-4 border-green-600 pl-6 italic text-lg md:text-xl text-gray-900 font-medium bg-green-50 rounded-md py-4 shadow-sm">
          “Every big journey starts with a small first step — and this office was
          ours.”
        </blockquote>

        <p>
          You can add more sections, bullet points, or even images here to make
          it look like a full article. Tailwind ensures it remains responsive.
        </p>

        {/* Sub Heading */}
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-8">
          Key Highlights
        </h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Opened our first office space in 2025</li>
          <li>Focused on innovation and teamwork</li>
          <li>Set strong foundations for growth</li>
        </ul>

        {/* Additional Section */}
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-8">
          Future Plans
        </h2>
        <p>
          We aim to expand our footprint, build more collaborative spaces, and
          continue fostering creativity and innovation across all teams.
        </p>
      </div>

      {/* Back Button */}
      <div className="mt-12">
        <Link
          to="/blog"
          className="inline-block px-5 py-2 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 transition"
        >
          ← Back to Blogs
        </Link>
      </div>
    </section>
  );
}
